<template>
  <div>
    <label
      :for="id"
      v-html="text"
    />
    <input
      :id="id"
      type="text"
      v-model="input"
    >
  </div>
</template>
<script>
export default {
  name: 'DegradedInput',
  props: {
    id: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
  },
  data() {
    return { input: '' }
  },

  watch: {
    input(newVal) {
      this.$emit('inputchange', newVal)
    },
    value(val) {
      this.input = val
    },
  },
  mounted() {
    this.input = this.value
  },
}
</script>
<style lang="scss" scoped>
div {
  display: flex;
  justify-content: space-between;
  margin: auto;
  max-width: 490px;
  padding: 0;
  width: 100%;
}

label {
  color: black;
  font-size: 1.6rem;
}

input {
  appearance: none;
  border: 1px solid;
  height: 40px;
}
</style>
